import React from "react";

import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";

class BulkActions extends React.Component {
  onConfirm() {
    const onSelectionConfirm = this.props.onSelectionConfirm || null;
    if (onSelectionConfirm) {
      onSelectionConfirm();
    }
  }

  onDelete() {
    const onSelectionDelete = this.props.onSelectionDelete || null;
    if (onSelectionDelete) {
      onSelectionDelete();
    }
  }

  render() {
    const { selected, hasDelete, hasMultipleSelection } = this.props;

    const isDeleteDisabled = selected.length === 0 ? true : false;
    const isConfirmDisabled = false;

    return (
      <div className="actions">
        <div className="left">
          {hasDelete && hasMultipleSelection && (
            <Button
              variant="contained"
              size="small"
              color="secondary"
              startIcon={<DeleteIcon />}
              disabled={isDeleteDisabled}
              onClick={() => this.onDelete()}
            >
              Delete
            </Button>
          )}
        </div>
        <div className="right">
          {this.hasCancel ?? false ? (
            <Button variant="outlined" size="small" startIcon={<ClearIcon />}>
              Cancel
            </Button>
          ) : null}

          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<CheckIcon />}
            disabled={isConfirmDisabled}
            onClick={() => this.onConfirm()}
          >
            {this.props.confirmText || "Confirm"}
          </Button>
        </div>
      </div>
    );
  }
}

export default BulkActions;
